import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { DataTestId, TextKey } from '@mews-commander/enums';
import { CommanderThunkDispatch } from '@mews-commander/types';
import { Button, IconName } from '@optimus-web/core';
import { LocalizedText, withScopeContext } from '@mews/framework';
import { openBillPreview } from '../../actions/bills';
import { isAnythingSelected } from '../../ducks/billItems';

interface StateProps {
    disabled: boolean;
}

interface DispatchProps {
    previewBill(): void;
}

type Props = StateProps & DispatchProps;

const BillPreviewButton: React.FC<Props> = ({ previewBill, disabled }) => (
    <Button
        variant="ghost"
        onClick={previewBill}
        disabled={disabled}
        data-test-id={DataTestId.BillingPreviewButton}
        icon={IconName.ReservationOverview}
        type="submit"
    >
        <LocalizedText textKey={TextKey.Preview} />
    </Button>
);

interface OwnProps {
    billId: string;
    scope: string;
}

export default withScopeContext(
    connect<StateProps, DispatchProps, OwnProps>(
        createStructuredSelector({
            disabled: isAnythingSelected,
        }),
        (dispatch: CommanderThunkDispatch, { billId, scope }) => ({
            previewBill: () => dispatch(openBillPreview({ billId, scope })),
        })
    )(BillPreviewButton)
);
